import React from "react";
import GenAIPractitioner from "../common/GenAIPractitioner";

const paths = [
  ["/Overview", "Cloud foundations", "Regions, availability zones, databases, and the AWS building blocks."],
  ["/CoreServices", "Core services", "Compute, IAM, and the services you reach for most often."],
  ["/Storage", "Storage", "S3, EBS, EFS, gateways, backups, and durable architecture choices."],
  ["/Network", "Network", "VPC, DNS, connectivity, security, and traffic flow."],
  ["/DataAnalytics", "Data & AI", "Analytics, ML, and the data services behind modern cloud workloads."],
  ["/AzureOverview", "Azure", "A concise companion for Microsoft Azure concepts."]
];

export default function HomeCloudOpsGuru() {
  return (
    <>
      <section className="page-intro home-hero">
        <p className="page-kicker">AWS • AZURE • ARCHITECTURE</p>
        <h1>Cloud notes for the work in front of you.</h1>
        <p>A focused library of service overviews, certification revision, and practical reminders for cloud builders.</p>
        <div className="hero-actions">
          <a className="button button--primary" href="#/Overview">Start with AWS overview <span>→</span></a>
          <a className="button button--quiet" href="#/AzureOverview">Explore Azure</a>
        </div>
      </section>

      <section className="path-grid" aria-label="Cloud learning paths">
        {paths.map(([path, title, description], index) => (
          <a href={`#${path}`} className="path-card" key={path}>
            <span className="path-card__number">0{index + 1}</span>
            <h2>{title}</h2>
            <p>{description}</p>
            <span className="path-card__arrow" aria-hidden="true">→</span>
          </a>
        ))}
      </section>

      <section className="home-section home-section--ai">
        <div className="section-heading">
          <p className="page-kicker">CERTIFICATION REVISION</p>
          <h2>AI Practitioner notes</h2>
          <p>Review AI services, core concepts, and references without leaving the cloud-learning hub.</p>
        </div>
        <GenAIPractitioner />
      </section>
    </>
  );
}
